import { render, staticRenderFns } from "./AgreementFrame.vue?vue&type=template&id=1ec2f773&scoped=true&"
import script from "./AgreementFrame.vue?vue&type=script&lang=js&"
export * from "./AgreementFrame.vue?vue&type=script&lang=js&"
import style0 from "./AgreementFrame.vue?vue&type=style&index=0&id=1ec2f773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2f773",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
